export const stringsKey = "MultiLanguageWidget";
export const englishStrings = {
	languageTitle1: " in ",
	fieldRequiredMessage1: "The",
	fieldRequiredMessage2: "field is required.",
};
